// extracted by mini-css-extract-plugin
module.exports = {"root":"Empty_root__3pa5k"};